import { Flex } from 'mds-web-ui'
import { motion } from 'motion/react'
import React, { forwardRef, useRef } from 'react'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { darkBackgroundColor } from '../constants/actionsThemeColours'
import AppUpdateIcon from './AppUpdateIcon'
import DarkModeButton from './DarkModeButton'
import { FlexGrow } from './ui/Flex'
import { MenuIcon } from './ui/icons'
import { LinkWithCircle } from './ui/Link'

export const navHeight = 40
export const navHeightPx = `${navHeight}px`

const IconLink = React.memo(({ isActive, icon: Icon, ...rest }) => (
  <LinkWithCircle p={0} m={0} {...rest}>
    <Icon filled={!isActive} />
  </LinkWithCircle>
))

const LinkContainerInner = forwardRef((props, ref) => (
  <Flex
    as="nav"
    role="navigation"
    bg="black"
    color="white"
    ref={ref}
    css={{ height: navHeight, borderBottom: '1px solid #262626' }}
  >
    <Flex mx={4} width={1} alignItems="center" {...props} />
  </Flex>
))

const MotionLinkContainer = motion.create(LinkContainerInner)

export const preferencesToggleSelector = '[data-nav-toggle="preferences"]'

const PreferencesLink = ({ preferencesVisible }) => {
  const navigate = useNavigate()
  const wasOpenRef = useRef(false)

  const to = preferencesVisible ? '/' : '/preferences'

  return (
    <IconLink
      to={to}
      data-nav-toggle="preferences"
      onPointerDown={() => {
        wasOpenRef.current = preferencesVisible
      }}
      onClick={(e) => {
        e.preventDefault()
        navigate(wasOpenRef.current ? '/' : '/preferences')
      }}
      isActive={preferencesVisible}
      icon={MenuIcon}
      aria-label="Open Preferences Menu"
      css={{ borderRadius: '5px' }}
      color="white"
      p={1}
      mr={2}
    />
  )
}

const TopNavInner = ({ preferencesVisible }) => (
  <MotionLinkContainer
    animate={{
      backgroundColor: preferencesVisible ? darkBackgroundColor : '#000000',
    }}
    transition={{
      backgroundColor: { delay: preferencesVisible ? 0.1 : 0, duration: 0.2 },
    }}
  >
    <PreferencesLink preferencesVisible={preferencesVisible} />
    <DarkModeButton pointerEvents={preferencesVisible ? 'none' : null} />
    <FlexGrow />
    <AppUpdateIcon />
  </MotionLinkContainer>
)

export const TopNav = connect((state) => ({
  preferencesVisible: state.location.preferencesVisible,
}))(TopNavInner)
